import { defineStore } from 'pinia';
import { getData } from '@/services/axios-service';
import { PlaceLocation } from '@/interfaces/elastic/elastic.interface';
import { BASE_URL } from '@/utils/constants/api-constants';
import { MapsState, Nationality } from '@/interfaces/maps/maps.interface';

const INITIAL_STATE: MapsState = {
  results: [],
  nationalities: [],
};

export const useMapsStore = defineStore({
  id: 'MapsStore',
  state: (): MapsState => ({
    ...INITIAL_STATE,
  }),
  actions: {
    async getNationalities() {
      try {
        const res = await getData<Nationality[]>(`${BASE_URL.MAPS}maps/nationalities`);
        const { success, data, error } = res;
        if (success && data) {
          this.nationalities = data;
          return res;
        } else {
          throw new Error(error);
        }
      } catch (error) {
        if (error instanceof Error) throw error;
        throw new Error(error?.toString() ?? 'Unknown error!');
      }
    },
    async searchDirection(q: string) {
      try {
        const { data, success, error } = await getData<PlaceLocation[]>(
          `${BASE_URL.MAPS}maps/search`,
          { q },
        );

        if (success && data) {
          this.results = data;

          return data;
        } else {
          throw new Error(error);
        }
      } catch (error) {
        if (error instanceof Error) throw error;
        throw new Error(error?.toString() ?? 'Unknown error!');
      }
    },
  },
});
